import { ALERT } from "../../constants";

const initState = {
  message: "",
  title: null,
  hidden: true,
  type: "",
};

const normalizePayload = (payload) => {
  if (payload && typeof payload === "object" && "text" in payload) {
    return { title: payload.title ?? null, message: payload.text };
  }
  return { title: null, message: payload };
};

const alertReducer = (state = initState, action) => {
  switch (action.type) {
    case ALERT.ALERT_SUCCESS: {
      const { title, message } = normalizePayload(action.payload);
      return { ...state, hidden: false, type: "success", title, message };
    }

    case ALERT.ALERT_ERROR: {
      const { title, message } = normalizePayload(action.payload);
      return { ...state, hidden: false, type: "error", title, message };
    }

    case ALERT.ALERT_HIDE:
      return {
        ...state,
        hidden: true,
        type: "",
      };

    default:
      return state;
  }
};

export default alertReducer;
